export function formatLinkBytes(bytes: number): string {
  if (bytes < 1_024) {
    return `${String(bytes)} B`;
  }
  const units = ["KB", "MB", "GB"] as const;
  let value = bytes / 1_024;
  let unitIndex = 0;
  while (value >= 1_024 && unitIndex < units.length - 1) {
    value /= 1_024;
    unitIndex += 1;
  }
  return `${value.toFixed(value >= 10 ? 1 : 2)} ${units[unitIndex]}`;
}

export function formatLinkExpiry(value: string): string {
  return new Intl.DateTimeFormat(undefined, {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(new Date(value));
}

export function safeDownloadName(value: string): string {
  const withoutControls = [...value]
    .map((character) => (character.charCodeAt(0) < 32 ? "_" : character))
    .join("");
  const sanitized = withoutControls
    .replaceAll(/[<>:"/\\|?*]/gu, "_")
    .replaceAll(/\s+/gu, " ")
    .replaceAll(/^\.+|\.+$/gu, "")
    .trim()
    .slice(0, 180);
  return sanitized || "download";
}

export async function copyShareLink(value: string): Promise<void> {
  await navigator.clipboard.writeText(value);
}

export async function shareOrCopyLink(value: string): Promise<"shared" | "copied"> {
  if (typeof navigator.share === "function") {
    await navigator.share({ url: value });
    return "shared";
  }
  await copyShareLink(value);
  return "copied";
}

export function saveVerifiedBlob(name: string, blob: Blob): void {
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = objectUrl;
  anchor.download = safeDownloadName(name);
  anchor.rel = "noopener";
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
  window.setTimeout(() => {
    URL.revokeObjectURL(objectUrl);
  }, 0);
}
